import React from 'react';
import CandidateSearch from '../components/CandidateSearch/CandidateSearch';
import AppLayout from '../metronic/layouts/AppLayout';

/**
 * All Candidates Page
 * Displays all candidates from the internal Firestore database
 * This was previously the "Internal Search" tab in PeopleSearch.jsx
 *
 * NO CODE DELETED - This is a direct extraction of the Internal tab functionality
 */
const AllCandidates = () => {
  return (
    <AppLayout>
      <div className="py-8 px-4 sm:px-6 lg:px-8">
        {/* CandidateSearch Component - Internal Database Search */}
        <CandidateSearch />
      </div>
    </AppLayout>
  );
};

export default AllCandidates;

